import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from './icons/CloseIcon';
const Modal = ({ children, title, isOpen, setIsOpen, closeable }) => {
    return (_jsx("div", { className: `sudoku-modal ${isOpen ? 'is-open' : ''}`, onClick: () => { if (closeable)
            setIsOpen(false); }, children: _jsxs("div", { className: "sudoku-modal__content", onClick: e => e.stopPropagation(), children: [_jsx("div", { className: "sudoku-modal__header", children: closeable ?
                        _jsx("button", { className: "sudoku-modal__close", onClick: () => setIsOpen(false), children: _jsx(CloseIcon, {}) }) : null }), title ? _jsx("h2", { className: "sudoku-modal__title", children: title }) : null, children] }) }));
};
export default Modal;
